import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, subtitle, icon, iconColor, trend, trendValue, onClick, badge }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`bg-card border border-border rounded-lg p-6 transition-all duration-200 ${
        onClick ? 'cursor-pointer hover:shadow-interactive hover:border-primary/30' : ''
      }`}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <div className="flex items-baseline gap-2">
            <h3 className="text-3xl font-semibold text-foreground">{value}</h3>
            {badge && (
              <span className={`notification-badge ${badge?.type} text-xs`}>
                {badge?.count}
              </span>
            )}
          </div>
          {subtitle && (
            <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>
        <div
          className="w-12 h-12 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon name={icon} size={24} color={iconColor} />
        </div>
      </div>
      {trend && (
        <div className="flex items-center gap-2">
          <Icon
            name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'}
            size={16}
            color={trend === 'up' ? 'var(--color-success)' : 'var(--color-error)'}
          />
          <span
            className={`text-sm font-medium ${
              trend === 'up' ? 'text-success' : 'text-error'
            }`}
          >
            {trendValue}
          </span>
          <span className="text-xs text-muted-foreground">vs mois dernier</span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;